export const TERMINALAPI = '/api/Terminal';

export const SUBTERMINALAPI = '/api/SubTerminal';

export const LDZAPI = '/api/Ldz';

export const EXITPOINTAPI = '/api/ExitPoint';

export const COUNTERPARTYAPI = '/api/Counterparty';
export const COUNTERPARTYSEARCHAPI = '/api/Counterparty/search';

export const UNIT_API = '/api/Units';

export const ADJACENT_TSO_API = '/api/AdjacentTso';

export const GET_NATIONAL_GRID_PARAMS = '/api/NationalGridParameters';

export const AUTOMATION_CONFIGURATION = '/api/AutomationConfiguration';

export const PATTERN_SPECIAL_CHARS =
  /^(?![0-9.,>&_()|–[\]\\/-]+$)[a-zA-ZÀ-úÀ-ÿÀ-ÖØ-öø-ÿ0-9\-.,>&_()|–[\]\\/ ]+$/;

export const SUB_TERMINAL = 'sub-terminal';
export const TERMINAL = 'terminal';
export const EXIT_POINT = 'exit-point';
export const LDZ = 'ldz';

export const FIELD_CODE = '/api/FieldCode';

export const MESSAGES = {
  ADD: 'Terminal added successfully!',
  ADD_FAILED: 'Add new terminal failed!',
  ADD_SUB_TERMINAL: 'Subterminal added successfully!',
  ADD_SUB_TERMINAL_FAILED: 'Add new subterminal failed!',
  ADD_COUNTERPARTY: 'Counterparty added successfully!',
  ADD_COUNTERPARTY_FAILED: 'Add new counterparty failed!',
  UPDATE: 'Terminal updated successfully!',
  UPDATE_FAILED: 'Update terminal failed!',
  UPDATE_SUB_TERMINAL: 'Subterminal updated successfully!',
  UPDATE_FAILED_SUB_TERMINAL: 'Update subterminal failed!',
  UPDATE_COUNTERPARTY: 'Counterparty updated successfully!',
  UPDATE_COUNTERPARTY_FAILED: 'Update counterparty failed!',
  UPDATE_ACTIVITY: 'Activity updated successfully!',
  UPDATE_ACTIVITY_FAILED: 'Update activity failed!',
  ACTIVE: 'Are you sure you want to Activate the',
  INACTIVE: 'Are you sure you want to Inactivate the',
  REQUIRED_TERMINAL: 'Terminal Name is required',
  REQUIRED_SUB_TERMINAL: 'Subterminal Name is required',
  REQUIRED_EIC_CODE: 'EIC Code is required',
  REQUIRED_ADJACENT_TSO: 'Adjacent TSO is required',
  INVALID_NAME:
    'Enter a valid name, it allows only alphanumeric and special characters  . , > - & _ ( ) [ ] | – / \\',

  REQUIRED_LDZ: 'LDZ is required',
  REQUIRED_EXIT_POINT: 'Exit Point is required',
  REQUIRED_COUNTERPARTY: 'Counterparty is required',
  NUMBER_PATTERN: 'Please enter a valid number',
  ADD_LDZ: 'LDZ added successfully!',
  ADD_LDZ_FAILED: 'Add New LDZ failed!',
  ADD_EXIT_POINT: 'Exit Point added successfully!',
  ADD_EXIT_POINT_FAILED: 'Add New Exit Point failed!',
  UPDATE_LDZ: 'LDZ updated successfully!',
  UPDATE_LDZ_FAILED: 'Update LDZ failed!',
  UPDATE_EXIT_POINT: 'Exit Point updated successfully!',
  UPDATE_FAILED_EXIT_POINT: 'Update Exit Point failed!',
  MAX_LENGTH_50: 'Maximum length should be 50 characters',
  MAX_LENGTH_100: 'Maximum length should be 100 characters',
  MAX_LENGTH_10: 'Maximum length should be 10 characters',

  // Unit Maintenance
  REQUIRED_SOURCE_UNIT: 'Unit Name is required',
  REQUIRED_TARGET_UNIT: 'Target Unit is required',
  REQUIRED_CONVERSION_RATE: 'Rate is required',
  REQUIRED_DECIMAL_PLACES: 'Decimal Places is required',
  MIN_DECIMAL_PLACES: 'Decimal Places must be greater than or equal to 0',
  MAX_DECIMAL_PLACES: 'Decimal Places must be less than or equal to 10',
  MAX_LENGTH_20: 'Maximum length should be 20 characters',
  CREATED_UNIT: 'Unit added successfully!',
  UPDATED_UNIT: 'Unit updated successfully!',
  CREATED_UNIT_FAILED: 'Add new Unit failed!',
  UPDATED_UNIT_FAILED: 'Updated unit failed!',

  // Adjacent TSO
  REQUIRED_TSO_NAME: 'Adjacent TSO Name is required',
  EIC_CODE: 'EIC Code is required',
  CREATED_TSO: 'Adjacent TSO added successfully!',
  UPDATED_TSO: 'Adjacent TSO updated successfully!',
  CREATED_TSO_FAILED: 'Add new Adjacent TSO failed!',
  UPDATED_TSO_FAILED: 'Updated Adjacent TSO failed!',

  // Field Codes
  REQUIRED_FIELD_CODE: 'Field code is required',
  REQUIRED_FIELD_NAME: 'Field code is required',
  CREATED_FIELD_CODE: 'Field Code added successfully!',
  UPDATED_FIELD_CODE: 'Field Code updated successfully!',
  CREATED_FIELD_CODE_FAILED: 'Add new field code failed!',
  UPDATED_FIELD_CODE_FAILED: 'Updated field code failed!',
  FIELD_CODE_EXISTS: 'Field code already exists!',

  // Automation Configuration
  UPDATED_RULE: 'Rule updated successfully!',
  UPDATE_RULE_FAILED: 'Update Rule failed!',
};

export const ACTIVITY_TYPE_API = '/api/Activity';

export const SERVICE_TYPE_API = '/api/ServiceType';

export const ACTIVITY_CLASS_TYPE_API = '/api/ActivityClassType';

export const POINT_TYPE_API = '/api/PointType';

export const NATIONAL_BALANCING_POINT_API = '/api/NationalBalancingPoint';
